/**
 * Environment Configuration
 * Centralized configuration for API endpoints and environment variables
 * 
 * HOW IT DETERMINES API URL:
 * 1. REACT_APP_API_BASE_URL from .env file takes priority
 * 2. If no .env variable, defaults to http://127.0.0.1:8000/api/v1 for both dev and prod
 */

const getEnvVar = (key, defaultValue = '') => {
  return process.env[`REACT_APP_${key}`] || defaultValue;
};

// NODE_ENV is set automatically by React Scripts:
// - npm start → NODE_ENV=development
// - npm run build → NODE_ENV=production
const isProduction = process.env.NODE_ENV === 'production';
const isDevelopment = process.env.NODE_ENV === 'development';

const getApiBaseUrl = () => {
  // Priority 1: Check .env file first (REACT_APP_API_BASE_URL)
  const envUrl = getEnvVar('API_BASE_URL', '').trim();
  
  // If .env file has a value, use it (even if empty string, respect it)
  if (envUrl !== '') {
    return envUrl;
  }
  
  // Priority 2: Default to localhost for both development and production
  if (process.env.NODE_ENV === 'development') {
    return 'http://127.0.0.1:8000/api/v1';
  }

  // Production → IIS reverse proxy
  return '/api/v1';
};

const finalApiUrl = getApiBaseUrl();

// Development helper: Log the API URL being used (only in development)
if (isDevelopment && typeof window !== 'undefined') {
  // Only log once to avoid spam
  if (!window.__API_URL_LOGGED) {
    console.log('🔧 API Configuration:', {
      'From .env': getEnvVar('API_BASE_URL', 'NOT SET'),
      'NODE_ENV': process.env.NODE_ENV,
      'Final URL': finalApiUrl,
      'Is Production': isProduction,
      'Is Development': isDevelopment
    });
    window.__API_URL_LOGGED = true;
  }
}

export const API_CONFIG = {
  BASE_URL: finalApiUrl,
  TIMEOUT: parseInt(getEnvVar('API_TIMEOUT', '30000'), 10),
  RETRY_ATTEMPTS: parseInt(getEnvVar('API_RETRY_ATTEMPTS', '3'), 10),
};

export const ENV = {
  NODE_ENV: process.env.NODE_ENV || 'development',
  IS_PRODUCTION: isProduction,
  IS_DEVELOPMENT: isDevelopment,
};

export const SECURITY_CONFIG = {
  TOKEN_REFRESH_THRESHOLD: 5 * 60 * 1000,
  SESSION_TIMEOUT: 30 * 60 * 1000,
  TOKEN_VALIDATION_INTERVAL: 5 * 60 * 1000,
};

export const FEATURES = {
  ENABLE_ANALYTICS: getEnvVar('ENABLE_ANALYTICS', 'false') === 'true',
  ENABLE_DEBUG: isDevelopment,
};

export const AUTHKEY_CONFIG = {
  API_KEY: getEnvVar('AUTHKEY_API_KEY', '73f790fd7a27e76b'),
  EMAIL_OTP_TEMPLATE_ID: getEnvVar('AUTHKEY_EMAIL_OTP_TEMPLATE_ID', '694'),
  EMAIL_OTP_EVENT_ID: getEnvVar('AUTHKEY_EMAIL_OTP_EVENT_ID', ''),
};

export default {
  API_CONFIG,
  ENV,
  SECURITY_CONFIG,
  FEATURES,
  AUTHKEY_CONFIG,
};

